exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* @todo Add transparent colors as a tailwind plugin */\n\n/* @todo change font-aweos to some more general classname like 'font-highlight'.\n         Add this behaviour to tailwind\n*/\n.bg-black-transparent[data-v-3d7b9aac] {\n  background: rgba(0, 0, 0, 0.3);\n}\n", ""]);

// exports
